"use client";

import type { useAuth } from "@tillix/tx-core/react";
import { toastManager } from "@tillix/ui-atoms/toast";
import type { UseFormReturn } from "react-hook-form";

type AuthStore = ReturnType<typeof useAuth>;

interface SendMagicLinkOptions {
  authStore: AuthStore;
  form: UseFormReturn<any>;
  email: string;
  mode: "sign-in" | "sign-up";
  t: (key: string) => string;
}

export async function sendMagicLink({
  authStore,
  form,
  email,
  mode,
  t,
}: SendMagicLinkOptions) {
  const result = await authStore.signInWithMagicLink({
    email,
    callbackURL: "/dashboard",
    newUserCallbackURL: "/onboarding",
    errorCallbackURL: "/sign-in",
  });

  if (result.error) {
    console.log("failed to send magic link, error:", {
      code: result.error.code,
      message: result.error.message,
    });
    toastManager.add({
      type: "error",
      title: t("auth.failedToSendMagicLink"),
      description:
        result.error.code === "too_many_requests"
          ? t("auth.tooManyMagicLinks")
          : result.error.message,
    });
    form.setError("root", {
      message: result.error.code ?? result.error.message,
    });
  } else {
    form.clearErrors("root");
    toastManager.add({
      title: t("auth.magicLinkSent"),
      description: t("auth.checkInboxForMagicLink"),
    });
  }
}
